var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 246.2,
    height: 38.35,
    viewBox: "0 0 246.2 38.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3362.8 -2658.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25-33.75C7.3-33.75,3.8-28.85,3.8-22.1V0H9.7V-13.35H30.05v-5.6H9.7v-3.2c0-3.15,1.6-5.7,6.95-5.7h13.6v-5.9Zm35,0C41.45-33.75,36-28.15,36-16.8,36-5.5,41.4,0,51.25,0h4.6C65.7,0,71.1-5.5,71.1-16.8c0-11.35-5.45-16.95-15.25-16.95Zm4.6,5.9c6.5,0,9.3,3.3,9.3,11,0,7.75-2.8,10.95-9.3,10.95h-4.6c-6.55,0-9.35-3.2-9.35-10.9,0-7.75,2.85-11.05,9.35-11.05Zm22.1-5.9v5.9h18.5c3.25,0,4.7,2.05,4.7,4.45a4.371,4.371,0,0,1-4.7,4.7H83.3c-3.7,0-5.3,1.55-5.3,5.35V0h5.9V-12.2a.745.745,0,0,1,.85-.85h8.8L101.25,0h6.55L99.95-13.5c5.15-1.45,7.15-5.95,7.15-10.15,0-5.4-3.25-10.1-10.85-10.1ZM119.6-26.7a1.818,1.818,0,0,1,2.05-1.95,2.083,2.083,0,0,1,2.1,1.45L133.6-5.65C135-1.8,137.15.6,141.85.6c5.2,0,7.75-2.95,7.75-7.4V-33.75h-5.95v26.7a1.814,1.814,0,0,1-2,1.9,2.279,2.279,0,0,1-2.15-1.4L129.65-28.1c-1.4-3.85-3.5-6.25-8.2-6.25-5.25,0-7.75,2.95-7.75,7.35V0h5.9Zm50.05-.45a1.706,1.706,0,0,1,1.7-1.15A1.607,1.607,0,0,1,173-27.15L183.25,0h6.55L178.4-30c-1.2-3.15-3.5-4.35-7-4.35-3.55,0-5.85,1.2-7.1,4.35L152.45,0h6.5Zm24.4-6.6,13.7,16.15L192.65,0h7.3l11.5-13.4L222.65,0h7.2L215.3-17.15l14.45-16.6h-7.3L211.6-21.3,201.25-33.75Z",
    transform: "translate(3359 2693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(3596 2684)",
    fill: "#dc2751"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f6560f651fc3315b31062369e3378808.svg";
export { ForwardRef as ReactComponent };